import antdImgCrop from "antd-img-crop";
import styled from "styled-components";

const ImgCrop = styled(antdImgCrop)`
  .ant-modal-title {
    font-family: "IBM Plex Sans Thai", "Helvetica";
    font-weight: 600 !important;
  }
`;

export default ImgCrop;
